/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2021, Zumper
 */

export enum ZUMPER_SITE_TYPES {
  CONSUMER = 'Consumer',
  MANAGE = 'Manage',
}
